import BaseApi from '../base/apiBase.service';

export default class CourseModuleService extends BaseApi {
  constructor(args) {
    super(args);

    this.serviceEndpoints = {
      baseUrl: process.env.REACT_APP_BACKEND_URL,
      get: '/api/coursemodule',
      create: '/api/coursemodule/',
      update: '/api/coursemodule/',
    };
  }

  async getByParameters(data) {
    return super.getByParameters(data);
  }

  async get(data) {
    return super.get(data, '/api/coursemodule/');
  }

  async create(data) {
    return super.create(data);
  }

  async update(data) {
    return super.update(data);
  }
}
